import styled from "styled-components";
import { RATypography } from "@/components/customs";
import { RAImage } from "@/components/customs";
import { Row, Col, Grid } from "antd";
import { PATH_PUBLIC_IMAGES } from "@/config/images";
import { useTrackVisibility } from "react-intersection-observer-hook";

import { IconHangar, IconAircraftCircle, IconEmployees } from "@/assets/images";
import { useEffect, useState } from "react";
import { formatNumber } from "@/utils";
import Image from "next/image";
const { useBreakpoint } = Grid;

export function JourneyCompanyAtGlance({ our_company_at_a_glance = {} }) {
	const [ref] = useTrackVisibility();
	const [imageWidth, setImageWidth] = useState("100%");
	const screens = useBreakpoint();
	const { aircraft = {}, hangar = {}, traveled_each_year = {} } = our_company_at_a_glance;

	useEffect(() => {
		if (window?.innerWidth > window?.innerHeight && window?.innerWidth >= 768) {
			setImageWidth("127vh");
		} else {
			setImageWidth("100%");
		}
	}, [screens]);

	return (
		<Container ref={ref}>
			<div
				style={{
					// height: "100vh",
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
				}}
			>
				<Padding>
					<div style={{ maxWidth: 876 }}>
						<Row justify="center">
							<RATypography
								variant={screens?.md ? "h2" : "h4"}
								align="center"
								style={{ textAlign: "center" }}
							>
								{our_company_at_a_glance?.title || ""}
							</RATypography>
						</Row>
						<Row justify="center">
							<RATypography
								variant="body3"
								color="#595959"
								align="center"
								style={{ textAlign: "center" }}
							>
								{our_company_at_a_glance?.description || ""}
							</RATypography>
						</Row>
					</div>
				</Padding>
				<MainImageRow>
					<Row justify="center" style={{ width: "100%", height: "100%" }}>
						<div
							style={{
								width: imageWidth,
								height: "38vh",
								maxWidth: "90vw",
								position: "relative",
							}}
						>
							<RAImage
								url={
									screens.xs
										? our_company_at_a_glance?.mobile_background_photo
										: our_company_at_a_glance?.desktop_background_photo ||
											PATH_PUBLIC_IMAGES.journey_company_at_glance
								}
								fill
								quality={100}
								sizes={"100vw"}
								borderRadius="12px"
								style={{
									objectFit: "cover",
									borderRadius: "12px",
								}}
							/>
						</div>
					</Row>
				</MainImageRow>
				<Padding
					style={{
						position: "relative",
						paddingTop: 0,
						paddingBottom: 0,
					}}
				>
					<ThirdRow gutter={[28, 20]}>
						<CardSectionItem
							icon={<RAImage url={IconAircraftCircle} width={44} height={44} />}
							title={`${formatNumber(aircraft?.number || 0)}${
								aircraft?.symbol || ""
							} ${aircraft?.unit || ""}`}
							description="Aircraft"
						/>
						<CardSectionItem
							icon={<RAImage url={IconHangar} width={44} height={44} />}
							title={`${formatNumber(hangar?.number || 0)}${hangar?.symbol || ""} ${hangar?.unit || ""}`}
							description="Hangars"
						/>
						<CardSectionItem
							icon={<RAImage url={IconEmployees} width={44} height={44} />}
							title={`${formatNumber(
								traveled_each_year?.number || 0,
							)}${traveled_each_year?.symbol || ""} ${traveled_each_year?.unit || ""}`}
							description="Employees"
						/>
					</ThirdRow>
				</Padding>
			</div>
		</Container>
	);
}

const CardSectionItem = ({ icon, title = "", description = "" }) => {
	return (
		<Col xl={8} lg={8} md={8} sm={8} xs={24}>
			<WrapperItem align="middle">
				<Col xxl={24} xl={24} lg={24} style={{ marginRight: 24 }}>
					{icon}
				</Col>
				<Col>
					<RATypography variant="h4">{title}</RATypography>
					<RATypography variant="body3" color="#595959">
						{description}
					</RATypography>
				</Col>
			</WrapperItem>
		</Col>
	);
};

const Container = styled.div`
	width: 100%;
	height: 100vh;
	background-image: url("/images/private-jet-travel/private-jet-travel-mask.png");
	background-repeat: no-repeat;
	background-size: cover;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	scroll-snap-align: start;
	padding: 84px 0;
	@media (max-width: 576px) {
		padding: 20px 0;
	}
`;
const Padding = styled.div`
	padding: 24px 136px;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	@media (max-width: 991px) {
		padding: 16px 80px;
	}
	@media (max-width: 767px) {
		padding: 12px 32px;
	}
	@media (max-width: 575px) {
		padding: 8px 16px;
	}
`;

const MainImageRow = styled.div`
	/* max-width: 1442px; */
	padding: 24px 0;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	@media (max-width: 1200px) {
		padding: 16px;
	}

	@media (max-width: 991px) {
		padding: 16px 80px;
	}
	@media (max-width: 767px) {
		padding: 12px 32px;
	}
	@media (max-width: 575px) {
		padding: 8px 16px;
	}
`;

const ThirdRow = styled(Row)`
	width: 85%;
	position: relative;
	top: -60%;
	padding: 20px 6px;
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
	border-radius: 16px;
	transition: all 0.3s ease-in-out;
	@media (max-width: 992px) {
		top: -50%;
	}
	@media (max-width: 768px) {
		top: -20%;
		width: 95%;
	}
`;

const WrapperItem = styled(Row)`
	width: 100%;
	height: 100%;
	padding: 16px 20px;
	background: #f9f9f9;
	border-radius: 16px;
`;
